import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { Box, Stack } from '@mui/material';

import FormProvider, { RHFAutocomplete } from '@/commons/hook-form';

import { Icon } from '@iconify/react';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { AutocompleteLabels } from '@/modules/orders/form/order-detail/products-items-list';
import { Order } from '@/modules/orders/types';
import { OrderHistory } from '@/utils';
import { useOrder } from '@/hooks/useOrder';
import { OrderStatus } from '@/modules/orders/page/cookingPanel';
import { defaultValuesForm } from './initial-values';

type Props = {
  lastId?: string;
  isEdit?: boolean;
  isLoading?: boolean;
  onSave: (values: any) => void;
};

export default function PopUnifyAccounts({ isEdit = false, onSave, isLoading, lastId }: Props) {
  const { isOpen } = useCashRegisterContext();
  const { palette } = useTheme();

  const defaultValues = useMemo(() => defaultValuesForm(), []);

  const methods = useForm<any>({
    defaultValues,
  });

  const { handleSubmit } = methods;

  const { data: dataOrders, refetch } = useOrder({
    filter: true,
    query: OrderHistory.OPEN,
  });

  const onSubmit = async (data: any) => {
    await onSave({ removeId: lastId, unitId: data.providerId?.value });
    await refetch();
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
      <Box sx={{ justifyContent: 'center', display: 'flex', mt: isOpen ? 2 : 0 }}>
        <Icon icon="codicon:combine" color={palette.info.main} width={100} />
      </Box>
      <Stack sx={{ px: 3, gap: 2, py: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        <RHFAutocomplete
          name="providerId"
          size="medium"
          label="Cuentas abiertas"
          options={
            dataOrders?.data?.filter?.((item: Order) => item.id !== lastId && (item.status === OrderStatus.Created || item.status === OrderStatus.REOPEN)).map?.((item: Order) => ({
              value: item.id,
              label: item.table,
            })) || []
          }
          isOptionEqualToValue={(option: AutocompleteLabels, selected: AutocompleteLabels) =>
            option.value === selected.value
          }
          fullWidth
        />
      </Stack>
      <Stack sx={{ justifyContent: 'center', my: isOpen ? 2 : 0 }}>
        <LoadingButton type="submit" variant="outlined" loading={isLoading}>
          Unir cuentas
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
